import React, { Component } from 'react'


import { Link, withRouter } from 'react-router-dom';

import { Typography, DatePicker, Input, Button, Tabs, Select, Pagination, Table, message} from 'antd';

// antd 和 moment 绑定了
import moment from 'moment'

import styles from './style.scss?__local'

import request from 'request'
import Title from 'antd/lib/typography/Title';

import 'moment/locale/zh-cn';

const { Option } = Select;

const { RangePicker } = DatePicker;
moment.locale('zh-cn');

const PAGE_SIZE = 10;

class FeeList extends Component {
  constructor(props) {
    super(props);

    this.state = {
      pageNum: 1,
      dataList: [],
      totalFee: 0,
      totalDataNum: 0,
      dateArrValue: [],
      extList: [
        {
          name: '全部小程序',
          extUuid: '',
        },
      ],
      selectedExtUuid: '',
      loading: false,
    }

    this.handleChange = this.handleChange.bind(this)
    this.handlePanelChange = this.handlePanelChange.bind(this)
    this.filterData = this.filterData.bind(this)
    this.switchPage = this.switchPage.bind(this)
    this.switchExt = this.switchExt.bind(this);
  }

  componentDidMount() {
    const { startTime } = this.props;

    this.setState({
      dateArrValue: [moment(startTime), moment(startTime)],
    }, () => {
      this.filterData();
    })
  }

  handleChange(dateArr) {
    this.setState({
      dateArrValue: dateArr,
    })

  }

  handlePanelChange(dateArr) {
    this.setState({
      dateArrValue: dateArr,
    })

  }

  filterData() {
    const { api, dataFormatter } = this.props;
    const { pageNum, dateArrValue } = this.state;

    const beginTime = dateArrValue[0].format('YYYY-MM');
    const endTime = dateArrValue[1].format('YYYY-MM');

    this.setState({
      loading: true,
    })

    request({
      url: api,
      type: 'GET',
      data: {
        pageNum,
        pageSize: PAGE_SIZE,
        beginTime,
        endTime,
      },
    })
      .done(res => {
        this.setState({
          totalDataNum: res.total,
          dataList: dataFormatter(res),
          totalFee: res.sum,
          loading: false,
        })
      })
      .fail(err => {
        message.warn(err);

        this.setState({
          loading: false,
        })
      })
  }

  switchPage(pageNum) {
    this.setState({
      pageNum,
    }, () => {
      this.filterData();
    })
  }

  switchExt(val) {
    this.setState({
      selectedExtUuid: val,
    })
  }

  getTable() {
    const { columnsList } = this.props;

    const { dataList, totalFee, totalDataNum, loading } = this.state;

    const columns = columnsList.map(item => ({
      title: item[0],
      dataIndex: item[1],
      key: item[1],
      render: text => <span>{text}</span>,
    }))

    const pagination = (!totalDataNum || !dataList.length || dataList.length <= PAGE_SIZE) ? false : {
      onChange: this.switchPage.bind(this),
      total: totalDataNum,
      defaultPageSize: PAGE_SIZE,
    }

    return (
      <>
        <Table columns={columns} dataSource={dataList} pagination={pagination} loading={loading}></Table>
        {
          totalFee > 0 ?
            <div className={styles.table_footer}>
              <Title level = {4}>总计：{totalFee / 100}虎牙币</Title>
            </div>
            :
            ''
        }
      </>
    )

  }


  render() {
    const { dateArrValue } = this.state;

    return (
      <div className={styles.data_wrapper}>
        <div className={styles.header}>
          <RangePicker
            placeholder={['开始月份', '结束月份']}
            format="YYYY-MM"
            onChange={this.handleChange}
            onPanelChange={this.handlePanelChange}
            mode={['month', 'month']}
            value = {dateArrValue}
          />

          <Button onClick = {this.filterData} className = {styles.search_btn} type="primary">查看</Button>
        </div>

        {
          this.getTable()
        }

        {/* {
                        !totalDataNum || !dataList.length ?
                        ""
                        :
                        <Pagination onChange={this.switchPage} total={totalDataNum} defaultPageSize={PAGE_SIZE} className={styles['pager']} />
                    } */}
      </div>
    )
  }
}

export default FeeList;
